import { ApiPage, emptyApiPage } from "../models/api-page.model";
import { DsFile } from "../models/ds-file.model";
import { templateModel } from "../models/template.model";

import { apiService } from "./api.service";

export class UploadFileService {
  private static BASE_PATH = "/api/v1/email-templates";

  static async uploadFile(file: File, callback?: (progress: number) => void, useApiEndpoint = true): Promise<DsFile | null> {
    const formData = new FormData();
    formData.append("file", file);

    const response = await apiService.upload(`${this.BASE_PATH}/bulk-upload`, formData, callback, false, true, useApiEndpoint);
    if (!response.success) return response.data as DsFile;

    return response.data as DsFile;
  }
  static async getTemplateList(term: string, page = 0, size = 10, sort = "templateName,asc"): Promise<ApiPage<templateModel>> {
    const response = await apiService.get(`${this.BASE_PATH}/?page=${page}&size=${size}&sort=${sort}&templateName=${term}`);
    if (!response.success) return emptyApiPage<templateModel>();
    return response.data as ApiPage<templateModel>;
  }

  static async deleteTemplate(formId: string): Promise<Request | boolean> {
    const response = await apiService.delete(`${this.BASE_PATH}/${formId}`);
    if (!response.success) return false;

    return response.data as Request;
  }

  static async templateDataBytemplateName(templateName: string): Promise<ApiPage<Request>> {
    const response = await apiService.get(`${this.BASE_PATH}/${templateName}`);
    if (!response.success) return emptyApiPage<Request>();

    return response.data as ApiPage<Request>;
  }

  static async addsingleTemplate(request: any): Promise<Request | null> {
    const response = await apiService.post(`${this.BASE_PATH}`, request);
    return response.data as Request;
  }

  static async updateSingleTemplate(request: any): Promise<Request | null> {
    const response = await apiService.put(`${this.BASE_PATH}/`, request);
    if (!response.success) return null;

    return response.data as Request;
  }
}
